import React from "react";
import { BrowserRouter, Route, Router, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Projects from "./pages/Projects/Projects";
import Navbar from "./utilities/Navbar";
import Contact from "./pages/Contact/Contact";
import Custom_modal from "./components/Custom_modal";
import Test from "./components/Test";
// import './index.css'

export default function App() {
  return (
    <>
      <MyNav />
      {/* <Custom_modal/> */}
    </>
  );
}

function MyNav() {
  return (
    <BrowserRouter>
        <Navbar></Navbar>
      <Routes>
        <Route element={<Home />} path="/"></Route>
        <Route element={<About />} path="/about"></Route>
        <Route element={<Projects />} path="/projects"></Route>
        <Route element={<Contact/>} path="/contact"></Route>
        {/* <Route element={<VendorDetailsForm/>} path="/test"></Route> */}
      </Routes>
    </BrowserRouter>
  );
}
